import { withRouter } from 'react-router-dom';
import BaseBlocos from '../../base/testes/BaseBlocos';

class Blocos extends BaseBlocos {

}

export default withRouter(Blocos);
